<template>
    <div class="single-quiz">
        <h1 v-html="question.question"></h1>

        <ul>
            <li class="answer" v-for="(answers,index) in question.answers" :key="index" :class="{active: selected === index}" @click="handleSelectChild(index)">
                <p><span>{{String.fromCharCode('a'.charCodeAt() + index)}}. </span> {{answers.answer}}</p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data: () => {
        return {
            selected: -1,
            that: this,
           }   
    },
    props: [
        'question'
    ],
    mounted(){
         this.$store.state.buttonDisabled = false;
    },
    methods: {
        handleSelectChild (index) {
            var vm = this;
            vm.selected = index;
            vm.$store.state.buttonDisabled = true;
        }
    },
    beforeDestroy() {
        var endDateSaveData = {
            'session_questions_fk': this.question.session_questions_id,
            'user_answer' : this.question.answers[this.selected],
            'type' : this.question.type,
        }
        this.axios.put('/backend/web/end-question?access-token='+this.$store.state.privateKey, endDateSaveData);    
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>